module.exports = __webpack_public_path__ + "static/media/admin-logo.71649a02.png";